let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page051_game10/img/bcg2.jpg',
    width: 1460,
    height: 910,
    pos: {
      x: 399,
      y: 142,
    },
  },
  activeArea: {
    width: 50,
    height: 50,
    fontSize: 35,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      id: '3',
      animation: true,
      // direction: 'left',
      textObj: {
        text: 'Kliknij w kategorię <i>Ruch</i>.',
      },
      audio: {
        src: 'games/page051_game10/audio/z25s51-3.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 463,
        y: 252,
      },
    },
    {
      id: '4',
      // direction: 'left',
      textObj: {
        text: 'Przeciągnij bloczek <i>Przesuń o 10 kroków</i>.',
      },
      audio: {
        src: 'games/page051_game10/audio/z25s51-4.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1073,
        y: 383,
      },
    },
    {
      id: '5',
      // direction: 'left',
      textObj: {
        text: 'Kliknij w liczbę 10 i&nbsp;wpisz liczbę 100.',
      },
      audio: {
        src: 'games/page051_game10/audio/z25s51-5.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1453,
        y: 671,
      },
    },
    {
      id: '6',
      direction: 'left',
      textObj: {
        text: 'Kliknij w kategorię <i>Wygląd</i>.',
      },
      audio: {
        src: 'games/page051_game10/audio/z25s51-6.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 466,
        y: 781,
      },
    },
    {
      id: '7',
      // direction: 'left',
      textObj: {
        text: 'Przeciągnij bloczek <i>Powiedz Cześć! przez&nbsp;2&nbsp;sekundy</i>.',
      },
      audio: {
        src: 'games/page051_game10/audio/z25s51-7.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1206,
        y: 921,
      },
    },
  ],
};
export default elements;
